import 'twin.macro'

import CardHandIcon from 'assets/icons/CardHandIcon'
import { Button } from 'components/UI/button/button'
import SubBody from 'components/UI/sub-body/sub-body'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import React, { useEffect, useState } from 'react'
import CurrencyFormat from 'react-currency-format'
import { useTranslation } from 'react-i18next'
import { useOrderCardMutation } from 'redux/api/buy-card.api'
import tw from 'twin.macro'

function AcceptDenominationChoice({
  denomination,
  onClose
}: {
  denomination: { amount: string; product_code: string }
  onClose: () => void
}) {
  const [error, setError] = useState<string | null>(null)
  const [order, { isSuccess, data: redirectUrl, isLoading }] = useOrderCardMutation()
  const { t } = useTranslation()

  const handleAccept = async () => {
    try {
      await order({ product_code: denomination.product_code }).unwrap()
    } catch (error) {
      const typedErr = error as {
        data: {
          error: { description: string }
        }
        status: number
      }
      if (typedErr.data.error.description) {
        setError(typedErr.data.error.description)
      }
    }
  }
  useEffect(() => {
    redirectUrl && window.open(redirectUrl?.data?.url, '_self')
  }, [redirectUrl])

  return (
    <div tw='flex flex-col items-center gap-5'>
      <CardHandIcon />
      <Title variant='bold'>{t('buy-card.title', { ns: 'landing' })}</Title>
      <SubTitle twStyle={tw`font-medium text-secondary`}>
        {t('buy-card.you_choosed', { ns: 'landing' })}{' '}
        <CurrencyFormat
          value={denomination.amount}
          displayType={'text'}
          format={parseInt(denomination.amount) < 100000 ? '## ######' : '### #####'}
        />
        ₸{' '}
      </SubTitle>
      {!error && (
        <Button variant='gradient' onClick={handleAccept} disabled={Boolean(error) || isLoading} loading={isLoading}>
          {t('buy-card.confirm', { ns: 'landing' })}
        </Button>
      )}
      <SubBody twStyle={tw`text-error`}> {error}</SubBody>
      {error && (
        <Button variant='gradient' onClick={() => location.reload()}>
          {t('buy-card.close', { ns: 'landing' })}
        </Button>
      )}
    </div>
  )
}

export default AcceptDenominationChoice
